import { defineMessages } from "react-intl";

import { node as abdominalCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/abdominalCtMrAngiography";
import { node as abdominalPelvisUltrasound } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/abdominalPelvisUltrasound";
import { node as carotisDoppler } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/carotisDoppler";
import { node as chestCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/chestCtMrAngiography";
import { node as chestXRay } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/chestXRay";
import { node as craniumCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/craniumCtMrAngiography";
import { node as lowerLimbCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/lowerLimbCtMrAngiography";
import { node as nativeAbdominalXRay } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/nativeAbdominalXRay";
import { node as neckCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/neckCtMrAngiography";
import { node as otherImagingProcedure } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/otherImagingProcedure";
import { node as upperLimbCtMrAngiography } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/upperLimbCtMrAngiography";
import { node as upperLimbDoppler } from "src/modules/ktx/forms/transplantation-screening/imaging-procedures/upperLimbDoppler";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.imaging_procedures",
		defaultMessage: "Képalkotó vizsgálatok"
	}
});

export const node: ParentNode = {
	id: "ktx-imaging-procedures",
	value: { type: "wizard", title: messages.title },
	children: [
		lowerLimbCtMrAngiography,
		otherImagingProcedure,
		upperLimbCtMrAngiography,
		upperLimbDoppler,
		abdominalCtMrAngiography,
		abdominalPelvisUltrasound,
		craniumCtMrAngiography,
		chestCtMrAngiography,
		chestXRay,
		nativeAbdominalXRay,
		neckCtMrAngiography,
		carotisDoppler
	]
};
